import type { ICompanyResponse } from '@/infrastructure/api-functions'

// 获取公司上市类型
export function getCompanyOwnershipType(company: ICompanyResponse): string | undefined {
    if (company.entity_type === 'Company' || !company.entity_type) {
        const ownershipType = company?.ownership_type?.length ? company.ownership_type[0] : ''

        if (ownershipType) {
            // ownershipType 不为空,取其第一个值
            // ownershipType 为空,取entityType
            return ownershipType
        }
    }

    return company.entity_type
}

export function getCompanyLocation(company: ICompanyResponse): string | undefined {
    const { state_name = '', country_name = '' } = company;
    const separatist = state_name && country_name ? ',' : '';

    return `${state_name}${separatist}${country_name}`
}
